export enum UserStatus {
    All = 0,
    Active,
    Archived,
}
